import React from "react";
import PropTypes from "prop-types";
import RazorPay from "./RazorPay";
import PAYUForm from "./PAYUForm";
import { PAYMENTPAGE } from "npmlinks-constants";
import { decidePG } from '../../utils';

const PaymentGateway = (props) => {
  const { success, componentName } = props;
  const { loadPG = false, PGName = PAYMENTPAGE.PAYMENT_GATEWAYS.PAYU } = decidePG(success);
  return (
    <div>
      {loadPG && PGName === PAYMENTPAGE.PAYMENT_GATEWAYS.PAYU && (
        <PAYUForm.component
          formData={success}
          componentName={componentName}
        />
      )}
      {loadPG && process.env.REACT_APP_RAZORPAY && PGName === PAYMENTPAGE.PAYMENT_GATEWAYS.RAZORPAY && (
        <RazorPay.component
          formData={success}
          componentName={componentName}
        />
      )}
    </div>
  );
}

PaymentGateway.propTypes = {
  componentName: PropTypes.string,
  success: PropTypes.shape({
    transaction: PropTypes.shape({
      banking: PropTypes.shape({}),
    }),
  }),
}

const getFinalComponent = component => component;
const ProjectComponent = {
  getFinalComponent,
  wrapper: PaymentGateway,
  component: PaymentGateway,
}

export default ProjectComponent;
export { default as PAYUForm } from "./PAYUForm";


// WEBPACK FOOTER //
// ./src/component/PaymentGateway/index.js